import { useState } from "react";

/* Un campo de contraseña con el ojito para ver lo que se escribió.
 *
 * Igna, 09/10, desde el celular, con «Correo o contraseña incorrectos.» en
 * pantalla: «Ahí debería tener el ojito para ver si la password está bien
 * escrita». En el teléfono no hay forma de saber si el error fue la clave o
 * el dedo, y la única salida era borrar todo y volver a tipear a ciegas.
 *
 * ── LO QUE CUIDA ───────────────────────────────────────────────────────────
 *
 *   · El botón es `type="button"`: adentro de un formulario, uno sin tipo es
 *     un SUBMIT, y tocar el ojito mandaría la clave a medio escribir.
 *   · El foco se queda en el campo (`preventDefault` al apretar): en el
 *     celular, si el campo pierde el foco se cierra el teclado, y para seguir
 *     escribiendo habría que volver a tocar el campo.
 *   · Al mostrarla, el teclado no autocorrige ni pone mayúscula: una clave
 *     «corregida» deja de ser la clave.
 *   · Recibe todo lo demás tal cual (id, autoComplete, autoFocus, disabled…):
 *     el `<label htmlFor>` de cada pantalla sigue apuntando al campo.
 */

const Ojo = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"
       fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const OjoTachado = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"
       fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10.6 5.1A10.7 10.7 0 0 1 12 5c6.4 0 10 7 10 7a17.8 17.8 0 0 1-3.2 4.2" />
    <path d="M6.6 6.6C3.8 8.4 2 12 2 12s3.6 7 10 7c1.9 0 3.6-.6 5-1.5" />
    <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
    <path d="M3 3l18 18" />
  </svg>
);

const CampoClave = ({ id, className = "", ...resto }) => {
  const [ver, setVer] = useState(false);
  return (
    <div className="campo-clave">
      <input
        {...resto}
        id={id}
        className={["campo-clave__input", className].filter(Boolean).join(" ")}
        type={ver ? "text" : "password"}
        autoCapitalize="none"
        autoCorrect="off"
        spellCheck={false}
      />
      <button
        type="button"
        className="campo-clave__ojo"
        aria-label={ver ? "Ocultar la clave" : "Mostrar la clave"}
        aria-controls={id}
        aria-pressed={ver}
        title={ver ? "Ocultar" : "Mostrar lo que escribiste"}
        disabled={resto.disabled}
        onMouseDown={(e) => e.preventDefault()}
        onClick={() => setVer((v) => !v)}
      >
        {ver ? <OjoTachado /> : <Ojo />}
      </button>
    </div>
  );
};

export default CampoClave;
